const testimonials = [
  {
    name: 'Marcus & Jennifer T.',
    location: 'Southlake, TX',
    rating: 5,
    title: 'Exceptional Framing Work',
    review: 'Allen Construction Group framed our entire custom home and the precision was unbelievable. They finished ahead of schedule and the quality was top-notch. We couldn\'t be happier with the results!',
    avatar: 'https://public.readdy.ai/ai/img_res/79a6c2f0da10aebd9fea4d13aa8d7991.jpg',
  },
  {
    name: 'David R.',
    location: 'Fort Worth, TX',
    rating: 5,
    title: 'Concrete Work Done Right',
    review: 'We needed a large commercial slab poured and Allen Construction delivered perfectly. The foundation is flawless and they kept us informed every step of the way. Highly recommend for any concrete work in DFW.',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20headshot%20of%20confident%20businessman%20smiling%2C%20warm%20neutral%20background%2C%20natural%20lighting%2C%20trustworthy%20appearance&width=80&height=80&seq=av002&orientation=squarish',
  },
  {
    name: 'Sarah M.',
    location: 'Plano, TX',
    rating: 5,
    title: 'Dream Kitchen Remodel',
    review: 'They transformed my outdated kitchen into something out of a magazine. The team was professional, clean, and communicative throughout the entire remodel. Worth every penny — I use my kitchen every day with a smile.',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20headshot%20of%20happy%20woman%20homeowner%20smiling%2C%20warm%20neutral%20background%2C%20natural%20lighting%2C%20friendly%20and%20satisfied%20expression&width=80&height=80&seq=av003&orientation=squarish',
  },
  {
    name: 'Robert & Lisa K.',
    location: 'Frisco, TX',
    rating: 5,
    title: 'New Build From Ground Up',
    review: 'Allen Construction Group handled the framing and concrete for our new build. Their attention to detail and communication made the whole process stress-free. We\'ll definitely use them again for our next project.',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20headshot%20of%20happy%20couple%20in%20their%2040s%20smiling%2C%20warm%20neutral%20background%2C%20natural%20lighting%2C%20homeowners%20looking%20satisfied&width=80&height=80&seq=av004&orientation=squarish',
  },
  {
    name: 'Carlos V.',
    location: 'Arlington, TX',
    rating: 5,
    title: 'Beautiful Concrete Driveway',
    review: 'Got a stamped concrete driveway and patio done. The crew was fast, professional, and the finished product looks amazing. My neighbors keep asking who did the work. Allen Construction is the real deal.',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20headshot%20of%20happy%20Latino%20man%20homeowner%20smiling%2C%20warm%20neutral%20background%2C%20natural%20lighting%2C%20friendly%20and%20proud%20expression&width=80&height=80&seq=av005&orientation=squarish',
  },
  {
    name: 'Amanda H.',
    location: 'McKinney, TX',
    rating: 5,
    title: 'Master Bath Transformation',
    review: 'I was nervous about a full bathroom remodel but Allen Construction made it seamless. They were on time, on budget, and the craftsmanship is stunning. My master bath looks like a luxury spa now!',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20headshot%20of%20happy%20woman%20in%20her%2030s%20smiling%2C%20warm%20neutral%20background%2C%20natural%20lighting%2C%20satisfied%20homeowner%20expression&width=80&height=80&seq=av006&orientation=squarish',
  },
];

export default function TestimonialsSection() {
  return (
    <section id="testimonials" className="py-24 bg-[#FBF7F0]">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="flex items-center justify-center gap-2 mb-3">
            <div className="w-2 h-2 bg-orange-500 rounded-full"></div>
            <span className="text-orange-500 text-sm font-bold tracking-widest uppercase">Client Reviews</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-black text-gray-900 mb-4">
            What Our Clients<br />
            <span className="text-orange-500">Say About Us</span>
          </h2>
          <p className="text-gray-500 text-base max-w-xl mx-auto">
            Real feedback from real DFW homeowners and businesses who trusted Allen Construction Group.
          </p>
        </div>

        {/* Cards Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {testimonials.map((t) => (
            <div
              key={t.name}
              className="bg-white rounded-2xl p-6 flex flex-col gap-4 hover:-translate-y-1 transition-transform duration-300"
            >
              {/* Stars */}
              <div className="flex items-center gap-1">
                {Array.from({ length: t.rating }).map((_, i) => (
                  <div key={i} className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-star-fill text-orange-400 text-sm"></i>
                  </div>
                ))}
              </div>

              <h3 className="font-black text-gray-900 text-base">{t.title}</h3>
              <p className="text-gray-500 text-sm leading-relaxed flex-1">&ldquo;{t.review}&rdquo;</p>

              {/* Author */}
              <div className="flex items-center gap-3 pt-2 border-t border-gray-100">
                <div className="w-12 h-12 rounded-full overflow-hidden flex-shrink-0">
                  <img
                    src={t.avatar}
                    alt={t.name}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div>
                  <div className="font-bold text-gray-900 text-sm">{t.name}</div>
                  <div className="text-gray-400 text-xs">{t.location}</div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom Trust Bar */}
        <div className="mt-16 flex flex-col md:flex-row items-center justify-center gap-8 text-center">
          {[
            { icon: 'ri-shield-star-line', text: 'Licensed & Insured' },
            { icon: 'ri-award-line', text: 'Award-Winning Quality' },
            { icon: 'ri-map-pin-2-line', text: 'Proudly Serving DFW' },
            { icon: 'ri-thumb-up-line', text: '5-Star Rated Service' },
          ].map((item) => (
            <div key={item.text} className="flex items-center gap-2 text-gray-600">
              <div className="w-6 h-6 flex items-center justify-center">
                <i className={`${item.icon} text-orange-500 text-lg`}></i>
              </div>
              <span className="font-semibold text-sm">{item.text}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
